import APIAccessor from "../apiProcessor";
import { COMMON_API_URL } from "constants/index";

class CommonService {
    protected api: APIAccessor;

    constructor() {
        this.api = new APIAccessor(COMMON_API_URL);
    }
}

export default CommonService;
